'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGrouping$002dPage$0024 from "./presto.-Edit-Grouping-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002455 from "./presto.-Presto-Router$$anon$55.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$54() {
  this.bj9 = null;
  this.bj1 = null;
  this.bj2 = false;
  this.bja = null;
  this.bjb = false;
  this.bje = null;
  this.bj7 = null;
  this.bj8 = false;
  this.bj3 = null;
  this.bj4 = false;
  this.bj5 = null;
  this.bj6 = false;
  this.bjc = false;
  this.bjd = false;
  this.bj9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bje = "EditGroupingPage";
}
export { $c_Lpresto_PrestoRouter$$anon$54 as $c_Lpresto_PrestoRouter$$anon$54 };
$p = $c_Lpresto_PrestoRouter$$anon$54.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$54;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$54() {
}
export { $h_Lpresto_PrestoRouter$$anon$54 as $h_Lpresto_PrestoRouter$$anon$54 };
$h_Lpresto_PrestoRouter$$anon$54.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bj9;
});
$p.M = (function() {
  if ((!this.bj2)) {
    this.bj1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bj2 = true;
  }
  return this.bj1;
});
$p.O = (function() {
  if ((!this.bjb)) {
    this.bja = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bjb = true;
  }
  return this.bja;
});
$p.E = (function() {
  return this.bje;
});
$p.t = (function() {
  if ((!this.bj8)) {
    this.bj7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("global", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bj8 = true;
  }
  return this.bj7;
});
$p.N = (function() {
  if ((!this.bj4)) {
    this.bj3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().nL(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().nM(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().at, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bj4 = true;
  }
  return this.bj3;
});
$p.Q = (function() {
  if ((!this.bj6)) {
    this.bj5 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002455.$c_Lpresto_PrestoRouter$$anon$55();
    this.bj6 = true;
  }
  return this.bj5;
});
$p.v = (function() {
  if ((!this.bjd)) {
    this.bjc = false;
    this.bjd = true;
  }
  return this.bjc;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee414) => ((p) => \u03b4scrutinee414.cFt(p)))($j_presto$002e$002dEdit$002dGrouping$002dPage$0024.$m_Lpresto_EditGroupingPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$54 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$54, "presto.PrestoRouter$$anon$54", ({
  Ov: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$54 as $d_Lpresto_PrestoRouter$$anon$54 };
//# sourceMappingURL=presto.-Presto-Router$$anon$54.js.map
